import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "line-clamp-2" }

import { Link, Image, Text } from '@sitecore-jss/sitecore-jss-vue';
import { ComponentFields } from '@sitecore-jss/sitecore-jss/types/layout';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'Tile',
  props: {
    fields: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Link), {
    field: _ctx.fields?.link,
    class: _normalizeClass(["flex flex-col gap-2 w-45 h-34 px-2.5 rounded-lg focus:rounded-lg active:rounded-lg bg-racq-true-white border-[1.5px] border-racq-pale-blue shadow-md hover:shadow-1xl active:shadow-none place-content-center text-paragraph-color no-underline text-center", _ctx.fields?.classes])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Image), {
        media: _ctx.fields?.icon,
        class: "w-15 h-15 mx-auto",
        width: "60",
        height: "60"
      }, null, 8, ["media"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Text), {
          tag: "p",
          field: _ctx.fields?.title,
          class: "text-m-bold text-ellipsis tracking-[-0.15px]"
        }, null, 8, ["field"])
      ])
    ]),
    _: 1
  }, 8, ["field", "class"]))
}
}

})